import React from "react";
import IPage from "../../interfaces/page"
import HomeClientComponent from "../../components/HomeClient/HomeClient.component";

const HomeClientPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <HomeClientComponent></HomeClientComponent>;
};

export default HomeClientPage;
